<template>
	<inertia-head title="Diamond Table" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Diamond Table</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Live and Replays of all Diamond Live Events.
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content mt-5">
		<div
			v-if="
				user.current_rank !== 'DIAMOND' &&
				!user.current_rank.startsWith('PLATINUM')
			"
		>
			<div class="alert alert-warning">
				<p class="mb-0 fw-semibold">
					UPGRADE to DIAMOND or HIGHER to view DIAMOND TABLE
				</p>
			</div>
		</div>
		<div v-else>
			<div v-if="featured" class="block block-rounded mb-5">
				<div class="block-header border-bottom">
					<h3 class="block-title fw-bold">{{ featured.title }}</h3>
				</div>
				<div class="block-content block-content-full">
					<div class="row">
						<div class="col-md-8">
							<div style="padding: 56.25% 0 0 0; position: relative">
								<iframe
									:src="`https://player.vimeo.com/video/${featured.video_id}`"
									style="
										position: absolute;
										top: 0;
										left: 0;
										width: 100%;
										height: 100%;
									"
									frameborder="0"
									allow="autoplay; fullscreen; picture-in-picture"
									allowfullscreen
								></iframe>
							</div>
						</div>
						<div class="col-md-4">
							<div style="padding: 56.25% 0 0 0; position: relative">
								<iframe
									:src="`https://vimeo.com/live-chat/${featured.video_id}`"
									style="
										position: absolute;
										top: 0;
										left: 0;
										width: 100%;
										height: 100%;
									"
									frameborder="0"
								></iframe>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- Replays -->
			<div v-if="videos.length > 0">
				<div class="row">
					<div v-for="video in videos" :key="video.id" class="m-auto mb-4" :class="videos.length===1 ? 'col-md-12' : 'col-md-6'">
						<div class="block block-rounded shadow">
							<div v-if="video.title" class="block-header border-bottom">
								<h3 class="block-title fw-bold">{{ video.title }}</h3>
							</div>
							<div class="block-content block-content-full p-1">
								<div style="padding: 56.25% 0 0 0; position: relative">
									<iframe
										:src="`https://player.vimeo.com/video/${video.video_id}`"
										style="
											position: absolute;
											top: 0;
											left: 0;
											width: 100%;
											height: 100%;
											border-bottom-left-radius: 0.875rem 1rem;
											border-bottom-right-radius: 0.875rem 1rem;
										"
										frameborder="0"
										allow="autoplay; fullscreen; picture-in-picture"
										allowfullscreen
									></iframe>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'

export default {
	layout: AuthLayout,
	props: {
		user: Object,
		featured: Object,
		videos: Object,
	},
	setup() {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})
	},
}
</script>
